import { render, staticRenderFns } from "./ll.vue?vue&type=template&id=482944e0"
import script from "./ll.vue?vue&type=script&lang=js"
export * from "./ll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482944e0')) {
      api.createRecord('482944e0', component.options)
    } else {
      api.reload('482944e0', component.options)
    }
    module.hot.accept("./ll.vue?vue&type=template&id=482944e0", function () {
      api.rerender('482944e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/we/ll.vue"
export default component.exports